<section class="connections-container">
  <section class="mb-4">
    <p-breadcrumb
      [model]="displayBreadcrumbs()"
      styleClass="rounded-lg border border-gray-200 dark:border-gray-800"
    >
      <ng-template pTemplate="separator">
        <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
      </ng-template>
      <ng-template let-item pTemplate="item">
        @if (item.routerLink) {
          <a
            [routerLink]="item.routerLink"
            class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
          >
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span>{{ item.label }}</span>
          </a>
        } @else {
          <span class="flex items-center text-primary-600 dark:text-primary-300">
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span class="font-medium">{{ item.label }}</span>
          </span>
        }
      </ng-template>
    </p-breadcrumb>
  </section>
  <section>
    <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4 gap-3 mb-4">
      <div class="flex items-center flex-col sm:flex-row col-span-1 md:col-span-2">
        <div
          class="flex items-center justify-center bg-primary-100 dark:bg-primary-500 rounded-full w-16 h-16 mr-2"
        >
          <i class="pi pi-globe text-primary-500 dark:text-primary-700 !text-3xl"></i>
        </div>
        <h2 class="text-3xl font-bold text-gray-900 dark:text-white text-center">
          {{ 'connections.title' | translate }}
        </h2>
      </div>
      <div class="flex flex-col md:flex-row md:justify-end gap-4 col-span-1 md:col-span-2">
        <lib-dropdown [items]="dropDownItems">
          <p-button
            [disabled]="mode === 'edit'"
            [icon]="'pi pi-plus'"
            [label]="'Crear nueva conexión'"
            styleClass="w-full md:w-auto"
          />
        </lib-dropdown>
      </div>
    </div>

    <lib-table
      (deleteConnectionEvent)="handleDelete($event)"
      (editConnectionEvent)="handleUpdateConnection($event)"
      [connections]="connections"
    ></lib-table>
  </section>
  <lib-connection-form
    (formSubmitted)="handleFormSubmit($event)"
    [mode]="mode"
  ></lib-connection-form>
</section>
